import React from "react";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/context/LanguageContext";
import { carTestLabels } from "@/i18n";

export interface SpeedSectionProps {
  speed: string;
  onSpeedChange: (value: number) => void;
  onNext: () => void;
  error?: string;
}

const SPEED_OPTIONS = [50, 70, 100];

const SpeedSection: React.FC<SpeedSectionProps> = ({
  speed,
  onSpeedChange,
  onNext,
  error,
}) => {
  const { language } = useLanguage();
  const form = (carTestLabels(language).form ?? {}) as Record<string, string>;

  const handleClick = (value: number) => {
    onSpeedChange(value);
    onNext();
  };

  return (
    <section>
      <label className="block font-semibold mb-2">
        {form.questionSpeed ?? "Vilken hastighet testkörde du fordonet med?"}
      </label>
      <div className="grid grid-cols-3 gap-2 mb-2">
        {SPEED_OPTIONS.map((option) => (
          <Button
            key={option}
            type="button"
            variant="formOption"
            className={
              Number(speed) == option
                ? "border-accent border-2"
                : "border-gray-400"
            }
            onClick={() => handleClick(option)}
          >
            {option} km/h
          </Button>
        ))}
      </div>
      {error && <div className="text-red-500 text-sm">{error}</div>}
    </section>
  );
};

export default SpeedSection;
